
import CompanyAppService from "@/apis.machine/CompanyAppService";
import CurrentLogier from "@/apis/CurrentLogier";
import { MiezzMenuTab } from "@/components/MiezzMenuTab.vue";
import DtoDetailCompanyCodeRule, {
  DtoDetailCompanyCodeRuleMiezzDetailItems,
} from "@/models.machine/DtoDetailCompanyCodeRule";
import DtoDetailCompanyCodeRule_CompanyCodeRule, {
  DtoDetailCompanyCodeRule_CompanyCodeRuleMiezzListItems,
} from "@/models.machine/DtoDetailCompanyCodeRule_CompanyCodeRule";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm from "@/models/MiezzForm";
import MiezzPageList from "@/models/MiezzPageList";
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
export default class CurrentCompanyCodeRuleDetail extends Vue {
  detail = new MiezzForm<DtoDetailCompanyCodeRule, string>();
  id?: string;
  list = new MiezzPageList<
    any,
    DtoDetailCompanyCodeRule_CompanyCodeRule,
    string
  >();
  buttons: MiezzButton[] = [
    {
      Code: "back",
      Label: "返回",
      MiezzIcon: "back",
      Type: "text",
      Size: "small",
    },
    {
      Code: "edit",
      Label: "编辑",
      Icon: "edit",
      Type: "text",
      Size: "small",
    },
  ];

  menuTab = new MiezzMenuTab();

  created(): void {
    this.menuTab.Url = this.$route.path;
    this.menuTab.Back = true;
    this.menuTab.Menus = [
      {
        Url: this.menuTab.Url,
        Label: "编号规则",
        Power: "CompanyManagement_Company_CodeRule",
      },
    ];

    this.id = this.$route.params.id as string;
    this.detail.Data = new DtoDetailCompanyCodeRule();
    this.detail.Items = JSON.copy(DtoDetailCompanyCodeRuleMiezzDetailItems);
    this.list.Fix = false;
    this.list.HideCard = true;
    this.list.Items = DtoDetailCompanyCodeRule_CompanyCodeRuleMiezzListItems;
    this.list.EnabledDynamicSearch = false;
    this.list.EnabledRadioSearch = false;
    this.list.EnabledSelect = false;
    this.list.EnabledPagination = false;
    this.list.Data = { Items: [] };

    this.handleGet();
  }

  handleGet(): void {
    CompanyAppService.GetCodeRuleById(this.id).then((r) => {
      if (r.data.Data) {
        this.detail.Data = r.data.Data;
        if (this.list.Data) this.list.Data.Items = r.data.Data.CodeRules;
      }
    });
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "edit":
        this.$router.push(`/org/company/code-rule/edit/${this.id}`);
        complete();
        break;
      case "back":
        CurrentLogier.Back();
        complete();
        break;
      default:
        break;
    }
  }
}
